import { CACHE_TIME } from '@/utils/helpers.ts'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutationCache: new MutationCache({
    onError(_error, _vars, _context, mutation) {
      if (mutation?.meta?.errorMessage) {
        toast.error(mutation.meta.errorMessage)
      }
    },

    async onMutate(_, mutation) {
      if (mutation?.meta?.cancelQueriesOnMutate) {
        const { cancelQueriesOnMutate } = mutation.meta

        const queryList = Array.isArray(cancelQueriesOnMutate)
          ? cancelQueriesOnMutate
          : [cancelQueriesOnMutate]

        for (const queryKey of queryList) {
          await queryClient.cancelQueries({ queryKey })
        }
      }
    },

    async onSuccess(_data, _vars, _context, mutation) {
      if (mutation.meta?.invalidateQueryOnSuccess) {
        const { invalidateQueryOnSuccess } = mutation.meta

        const queryList = Array.isArray(invalidateQueryOnSuccess)
          ? invalidateQueryOnSuccess
          : [invalidateQueryOnSuccess]

        for (const queryKey of queryList) {
          await queryClient.invalidateQueries({ queryKey })
        }
      }

      if (mutation.meta?.successMessage) {
        toast.success(mutation.meta.successMessage)
      }
    },
  }),
  defaultOptions: {
    mutations: {
      retry: 2,
    },
    queries: {
      retry: 2,
      staleTime: CACHE_TIME.ONE_MINUTE,
    },
  },
})
